/* ============================================================
   Inner Dragon — Cart Drawer Extras · JS v20
   קובץ: assets/ids-cart-extras.js (החלפה מלאה)
   זיהוי: זה קובץ הסקריפט — מתחיל ב-(function () {
   v22: מצב-פוקוס להחלפת מתנה — לחיצה על "החלפה" מעמעמת את כל
   הסל ומשאירה רק את ווידג'ט המתנה חד (ids-gift-swap-open).
   היציאה: בחירה, "להישאר עם הנוכחית", או כל רענון סל.
   v21: עמעום תוכן הסל כשההצצה פתוחה (ids-peek-open) — ישירות
   על התוכן, כמו מנגנון ה-busy המוכח.
   v20: שני תיקונים על גבי v19, בלי שינויים אחרים:
   (1) ההצצה = חלון קטן ממורכז עם רקע מעומעם (✕ בפינה, לחיצה
       על הרקע סוגרת) במקום פאנל על כל המגירה. במובייל: bottom-sheet.
   (2) טבלת המידות נשאבת מ-.page__content — גוף עמוד הטבלה
       עצמו — במקום סלקטור גנרי שתפס את פס ההכרזה.
   v19: הצצת מוצר בתוך הסל — הקשה על תמונה/שם בכרטיס האפסייל
   פותחת חלון בתוך המגירה: גלריית תמונות בסוויפ,
   מידות במלאי, תיאור קצר, טבלת מידות (נמשכת מעמוד הטבלה
   המתאים למשפחת המוצר), והוספה לסל — בלי לצאת מהסל.
   v18: כרטיס אפסייל נקי בסגנון Apple (progressive disclosure) —
   במקום שורת pills קבועה: שורה שקטה "מידה S · שינוי" עם המידה
   שכבר בסל נבחרת מראש. "הוספה" = לחיצה אחת. הקשה על "שינוי"
   פותחת כפתורי מידות (רק מה שבמלאי), בחירה מקפלת חזרה.
   v17: אפסייל בפעולה אחת אמיתית — כפתורי מידה (pills) במקום
   dropdown, והמידה שכבר בסל מסומנת מראש. "הוספה" עובדת מיד
   בלי בחירה נוספת ובלי איתות אדום; החלפת מידה = הקשה על pill.
   אם המידה מהסל אזלה — נבחרת הזמינה הראשונה (תמיד יש בחירה).
   v16: (1) הסדר שנקבע ידנית ב-Search & Discovery (מוצרים משלימים)
   מנצח — פריטי הסט מוצגים ראשונים. מיון "הזול שסוגר את הפער" חל
   רק בחלון פער-המשלוח (עד ₪60 ליעד), יחד עם המיקרו-קופי של v14.
   (2) חיצים לדסקטופ — מופיעים רק בעכבר (hover+pointer:fine),
   במובייל נשאר סוויפ נקי.
   v15: אפסייל קרוסלה חכמת-מידות —
   (1) הפול נבנה משני מקורות (complementary + related, בלי כפילויות)
       כדי שתמיד יהיה מבחר.
   (2) סינון מידות: מוצרים שקיימים במלאי במידות שכבר בסל
       (data-cart-sizes מהסקשן) מוצגים ראשונים; אם אין מספיק —
       משלימים במוצרים כלליים זמינים. אף פעם לא מבוי סתום.
   (3) תצוגה: סוויפ אופקי עם נקודות (scroll-snap) במקום שורות —
       עד data-limit מוצרים בלי עומס ויזואלי.
   v14: מצב-פער למשלוח חינם — כשחסר עד ₪60 ליעד המשלוח (נגזר
   דינמית מ-data-goal-ship) והפס מציג פריט שסוגר את הפער עד ₪200,
   הפריטים הסוגרים ממוינים מהזול ליקר והכותרת מתחלפת:
   עוד ₪X למשלוח חינם — אפשר להשלים עם אחד מאלה.
   + תיקון: הוגדר TERMS_KEY ותוקן משתנה לא מוגדר במאזין
   ה-change (מנע שגיאת קונסול).
   v13: אפסייל בפעולה אחת — בחירת מידה מוסיפה לסל מיידית.
   v12: אפסייל — בורר המידה מתחיל ב-placeholder של מידה במקום
   בחירה אקראית; לחיצה על הוספה בלי מידה = איתות אדום שקט.
   v11: הסרת קוד קופון — כפתור ✕ על תגית ההנחה (removeCoupon).
   + כל הקודם (v10): אפסייל חכם-פערים, פותחן ביטחון, שומר-סף,
   שומר מתנה, כמות אופטימית.
   ============================================================ */
(function () {
  'use strict';
  if (window.__IDS_CART_EXTRAS_BOOTED) return;
  window.__IDS_CART_EXTRAS_BOOTED = true;

  var initTimer = null;
  var observer = null;
  var recommendationsCache = {};
  var recommendationRequests = {};
  var checkoutQueued = false;
  var checkoutSubmitting = false;

  /* ───────── עזרים בסיסיים ───────── */

  function getDrawer() {
    return document.querySelector('cart-drawer[data-section-id]');
  }

  var deliveryClock = null;
  var deliveryFormats = null;
  var deliveryEstimateCache = null;

  function getDeliveryFormats() {
    if (!deliveryFormats) {
      var hebrew = new Intl.DateTimeFormat('en-US-u-ca-hebrew-nu-latn', {
        timeZone: 'UTC', year: 'numeric', month: 'long', day: 'numeric'
      });
      if (hebrew.resolvedOptions().calendar !== 'hebrew') throw new Error('Calendar unavailable');
      deliveryFormats = {
        hebrew: hebrew,
        israel: new Intl.DateTimeFormat('en-CA-u-ca-gregory-nu-latn', {
          timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit'
        })
      };
    }
    return deliveryFormats;
  }

  function deliveryDateParts(formatter, date) {
    var values = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return values;
  }

  function israelDeliveryDay(now) {
    var parts = deliveryDateParts(getDeliveryFormats().israel, now);
    return new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
  }

  function deliveryDayKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function deliveryHoliday(date) {
    var parts = deliveryDateParts(getDeliveryFormats().hebrew, date);
    var month = parts.month;
    var day = Number(parts.day);
    var weekday = date.getUTCDay();
    if (!/^(Tishri|Tishrei|Heshvan|Cheshvan|Kislev|Tevet|Shevat|Shvat|Adar|Adar I|Adar II|Nisan|Iyar|Iyyar|Sivan|Tamuz|Tammuz|Av|Elul)$/.test(month)) {
      throw new Error('Calendar month unavailable');
    }
    var major = /^(Tishri|Tishrei)$/.test(month) && [1, 2, 10, 15, 22].indexOf(day) !== -1;
    major = major || (month === 'Nisan' && (day === 15 || day === 21));
    major = major || (month === 'Sivan' && day === 6);
    if (month === 'Iyar' || month === 'Iyyar') {
      var fifth = new Date(date.getTime() + (5 - day) * 86400000).getUTCDay();
      var observed = fifth === 6 ? 3 : fifth === 5 ? 4 : fifth === 1 ? 6 : 5;
      major = major || day === observed;
    }
    var bank = /^(Adar|Adar II)$/.test(month) && day === 14;
    bank = bank || (month === 'Av' && ((day === 9 && weekday !== 6) || (day === 10 && weekday === 0)));
    var intermediate = (month === 'Nisan' && day >= 16 && day <= 20) ||
      (/^(Tishri|Tishrei)$/.test(month) && day >= 16 && day <= 21);
    return { major: major, bank: bank, intermediate: intermediate };
  }

  function calculateDeliveryEstimate(now, options) {
    var count = Number(options.days);
    if (!Number.isInteger(count) || count < 1 || count > 14) throw new Error('Invalid delivery days');
    var closed = {};
    String(options.closed || '').split(/[\s,;]+/).filter(Boolean).forEach(function (key) {
      var parsed = new Date(key + 'T12:00:00Z');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(key) || isNaN(parsed.getTime()) || deliveryDayKey(parsed) !== key) {
        throw new Error('Invalid closure date');
      }
      closed[key] = true;
    });
    var date = israelDeliveryDay(now);
    var scanned = 0;
    while (count > 0 && scanned < 366) {
      date.setUTCDate(date.getUTCDate() + 1);
      scanned++;
      if (date.getUTCDay() === 5 || date.getUTCDay() === 6 || closed[deliveryDayKey(date)]) continue;
      var holiday = deliveryHoliday(date);
      if (holiday.major || holiday.bank || (options.cholHamoed && holiday.intermediate)) continue;
      if (options.eves) {
        var next = new Date(date.getTime() + 86400000);
        if (deliveryHoliday(next).major) continue;
      }
      count--;
    }
    if (count > 0) throw new Error('No delivery day available');
    return date;
  }

  function syncDeliveryEstimate() {
    clearTimeout(deliveryClock);
    var drawer = getDrawer();
    var row = drawer && drawer.querySelector('[data-ids-delivery-estimate]');
    if (!row) return;
    try {
      var now = new Date();
      var options = {
        days: row.getAttribute('data-business-days'),
        eves: row.getAttribute('data-exclude-eves') === 'true',
        cholHamoed: row.getAttribute('data-exclude-chol-hamoed') === 'true',
        closed: row.getAttribute('data-closed-dates')
      };
      var locale = row.getAttribute('data-locale') || 'he';
      var cacheKey = deliveryDayKey(israelDeliveryDay(now)) + '|' + locale + '|' + JSON.stringify(options);
      if (!deliveryEstimateCache || deliveryEstimateCache.key !== cacheKey) {
        var date = calculateDeliveryEstimate(now, options);
        var label = new Intl.DateTimeFormat(locale, {
          timeZone: 'UTC', calendar: 'gregory', day: 'numeric', month: 'long', year: 'numeric'
        }).format(date);
        deliveryEstimateCache = {
          key: cacheKey, iso: deliveryDayKey(date),
          text: date.getUTCDate() + '.' + (date.getUTCMonth() + 1), label: label
        };
      }
      var time = row.querySelector('[data-ids-delivery-date]');
      if (!time) throw new Error('Delivery date missing');
      if (time.textContent !== deliveryEstimateCache.text) time.textContent = deliveryEstimateCache.text;
      if (time.getAttribute('datetime') !== deliveryEstimateCache.iso) time.setAttribute('datetime', deliveryEstimateCache.iso);
      if (time.getAttribute('aria-label') !== deliveryEstimateCache.label) time.setAttribute('aria-label', deliveryEstimateCache.label);
      if (row.hidden) row.hidden = false;
    } catch (error) {
      if (!row.hidden) row.hidden = true;
    }
    if (!document.hidden) deliveryClock = setTimeout(syncDeliveryEstimate, 60000);
  }

  function getSectionId() {
    var d = getDrawer();
    return d ? d.getAttribute('data-section-id') : null;
  }

  function rootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function cartApiUrl(file) {
    return rootUrl() + 'cart/' + file;
  }

  function cartStateUrl() {
    return rootUrl() + 'cart.js';
  }

  function withCartSection(payload) {
    var id = getSectionId();
    if (id) {
      payload.sections = [id];
      payload.sections_url = window.location.pathname || '/';
    }
    return payload;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/\x22/g, '&quot;').replace(/\x27/g, '&#39;');
  }

  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    return '₪' + n; /* ₪ */
  }

  /* IDS 3.11.2026: מחיר-אחרי-הנחה-אוטומטית לתצוגה בהמלצות (אפסייל/הצצה) — אותו חישוב כמו snippets/ids-sale-calc.liquid:
     בחלון הסייל (window.IDS_SALE נכתב ב-sections/cart-drawer.liquid) לפי תג sale-pct-NN / sale-off-NN. מחזיר null כשאין סייל. */
  function salePrice(p) {
    var win = window.IDS_SALE;
    if (!win || !p || !(p.price > 0)) return null;
    var now = Math.floor(Date.now() / 1000);
    if (!(win.start > 0) || now < win.start || now > win.end) return null;
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); });
    var off = 0;
    tags.forEach(function (t) {
      if (t.indexOf('sale-pct-') === 0) off = Math.floor(p.price * (parseInt(t.slice(9), 10) || 0) / 100);
      else if (t.indexOf('sale-off-') === 0) off = (parseInt(t.slice(9), 10) || 0) * 100;
    });
    return off > 0 && off < p.price ? p.price - off : null;
  }

  function saleLaunch(p) {
    var tags = Array.isArray(p && p.tags) ? p.tags : String((p && p.tags) || '').split(',');
    return tags.some(function (t) { return String(t).trim() === 'launch-price'; });
  }

  /* HTML למחיר: מחיר סייל + מחיר מלא מחוק (מחיר השקה — בלי קו חוצה) */
  function priceHtml(p) {
    var sale = salePrice(p);
    if (sale == null) {
      return money(p.price) + (p.compare_at_price && p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '');
    }
    return '<span class="ids-sale-price">' + money(sale) + '</span>' +
      (saleLaunch(p) ? ' <small class="ids-sale-launch">מחיר השקה</small>' : ' <s>' + money(p.price) + '</s>');
  }

  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function setBusy(el, on) {
    if (!el) return;
    el.classList[on ? 'add' : 'remove']('is-busy');
  }

  function setDrawerBusy(on) {
    var d = getDrawer();
    on = on || giftGuardBusy;
    if (d) d.classList[on ? 'add' : 'remove']('ids-busy');
    if (!on) flushQueuedCheckout();
  }

  /* ───────── Cart AJAX API ───────── */

  function cartAdd(variantId, qty) {
    return fetch(cartApiUrl('add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withCartSection({
        items: [{ id: Number(variantId), quantity: qty || 1 }]
      }))
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function cartChangeLine(line, qty, options) {
    var payload = { line: Number(line), quantity: qty };
    if (!options || options.render !== false) withCartSection(payload);
    return fetch(cartApiUrl('change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ───────── רענון המגירה מהשרת ───────── */

  function matchingGiftUpsell(current, fresh) {
    var oldBox = current.querySelector('[data-ids-upsell]');
    var newBox = fresh.querySelector('[data-ids-upsell]');
    if (!oldBox || !newBox || oldBox.hidden || !oldBox.classList.contains('is-in')) return null;
    var attrs = ['data-product-id', 'data-limit', 'data-cart-sizes', 'data-goal-gift', 'data-goal-ship', 'data-cart-total', 'data-gift-eligible-total'];
    if (!attrs.every(function (name) { return oldBox.getAttribute(name) === newBox.getAttribute(name); })) return null;
    function items(root) {
      return Array.from(root.querySelectorAll('.cart-item')).map(function (item) {
        return ['data-variant-id', 'data-handle', 'data-quantity', 'data-price'].map(function (name) {
          return item.getAttribute(name);
        });
      });
    }
    if (JSON.stringify(items(current)) !== JSON.stringify(items(fresh))) return null;
    return oldBox;
  }

  function refreshDrawer(cartState, options) {
    var id = getSectionId();
    if (!id) return Promise.resolve();

    var bundledHtml = cartState && cartState.sections && cartState.sections[id];
    var htmlPromise = bundledHtml
      ? Promise.resolve(bundledHtml)
      : fetch(rootUrl() + '?sections=' + encodeURIComponent(id))
          .then(function (r) { return r.json(); })
          .then(function (sections) { return sections && sections[id]; });

    return htmlPromise
      .then(function (html) {
        if (!html) return;
        var tmp = new DOMParser().parseFromString(html, 'text/html');
        if (!cartState || !Array.isArray(cartState.items) ||
            typeof cartState.item_count !== 'number' || typeof cartState.total_price !== 'number') {
          var sections = cartState && cartState.sections ? cartState.sections : {};
          sections[id] = html;
          cartState = serializedCartState(tmp, sections) || cartState;
        }
        var fresh = tmp.querySelector('cart-drawer');
        var current = getDrawer();
        if (!fresh || !current) return;
        /* מחליפים רק את אזור התוכן — כפתור הסגירה והאוברליי
           נשארים אלמנטים מקוריים עם ה-listeners של התבנית */
        ['data-cart-item-count','data-cart-items-subtotal-price','data-cart-total-price','data-gift-eligible-total'].forEach(function(name){
          if(fresh.hasAttribute(name)) current.setAttribute(name,fresh.getAttribute(name));
        });
        var freshContent = fresh.querySelector('.drawer__content');
        var curContent = current.querySelector('.drawer__content');
        /* שמירת מיקום הגלילה של גוף העגלה לאורך הרענון */
        var bodyEl = current.querySelector('.cart-drawer__body');
        var scrollPos = bodyEl ? bodyEl.scrollTop : 0;
        var savedUpsell = options && options.preserveGiftUpsell ? matchingGiftUpsell(current, fresh) : null;
        var savedList = savedUpsell && savedUpsell.querySelector('[data-ids-upsell-list]');
        var savedListScroll = savedList ? savedList.scrollLeft : 0;
        if (freshContent && curContent) {
          curContent.innerHTML = freshContent.innerHTML;
          var newUpsell = savedUpsell && curContent.querySelector('[data-ids-upsell]');
          if (newUpsell) {
            savedUpsell.setAttribute('data-exclude', newUpsell.getAttribute('data-exclude') || '');
            newUpsell.replaceWith(savedUpsell);
            if (savedList) savedList.scrollLeft = savedListScroll;
          }
        }
        else current.innerHTML = fresh.innerHTML;
        var newBodyEl = current.querySelector('.cart-drawer__body');
        if (newBodyEl && scrollPos) newBodyEl.scrollTop = scrollPos;
      })
      .then(function () {
        return syncHeader(cartState);
      })
      .catch(function () {})
      .then(function () {
        setDrawerBusy(false);
        /* v22: כל רענון סל מפזר את מצב-הפוקוס של החלפת המתנה —
           רשת ביטחון שהעמעום לעולם לא נתקע */
        var dd = getDrawer();
        if (dd) dd.classList.remove('ids-gift-swap-open');
        scheduleInit();
      });
  }

  /* שומר המתנה: מתנה אחת בלבד, בכמות 1 בלבד.
     חוסם הוספה ידנית של מתנות מעמודי המוצר (שורות free_gift
     נסתרות מהעגלה והיו עוברות בחינם לתשלום). */
  var giftGuardBusy = false;

  function enforceGiftRules(cart) {
    if (giftGuardBusy) return;
    var gifts = (cart.items || []).filter(function (it) {
      return it.product_type === 'free_gift';
    });
    if (!gifts.length) return;
    var drawer = getDrawer();
    var minimum = drawer ? Number(drawer.getAttribute('data-gift-minimum')) : NaN;
    var hasProducts = cart.items.some(function (item) {
      return !item.gift_card && item.product_type !== 'free_gift' && item.quantity > 0;
    });
    var excludedTotal = cart.items.reduce(function (total, item) {
      return item.gift_card || item.product_type === 'free_gift'
        ? total + (Number(item.final_line_price) || 0) : total;
    }, 0);
    var eligible = hasProducts && Number.isFinite(minimum) &&
      Math.max(0, cart.total_price - excludedTotal) >= minimum;
    var updates = {};
    var dirty = false;
    gifts.forEach(function (g, i) {
      var want = eligible && i === 0 ? 1 : 0; /* שומרים את הראשונה בלבד */
      if (g.quantity !== want) {
        updates[g.key || g.id] = want;
        dirty = true;
      }
    });
    if (!dirty) return;
    giftGuardBusy = true;
    setDrawerBusy(true);
    fetch(cartApiUrl('update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withCartSection({ updates: updates }))
    })
      .then(function (r) { if (!r.ok) throw new Error('gift-update-failed'); return r.json(); })
      .then(refreshDrawer)
      .catch(function () {})
      .then(function () { giftGuardBusy = false; setDrawerBusy(false); });
  }

  /* עדכון ספירת הסל בכותרת + אירועים לתבנית */
  /* Native quantity/remove renders update body and footer, but leave the header.
     Reuse their bundled section HTML so goals stay current without another request. */
  function syncCartGoals(cart) {
    var id = getSectionId();
    var html = cart && cart.sections && cart.sections[id];
    var drawer = getDrawer();
    var currentGoals = drawer && drawer.querySelector('[data-ids-cart-goals]');
    if (!currentGoals || typeof html !== 'string') return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshGoals = doc.querySelector('[data-ids-cart-goals]');
    if (freshGoals && currentGoals.innerHTML !== freshGoals.innerHTML) {
      currentGoals.innerHTML = freshGoals.innerHTML;
    }
  }

  function syncDrawerItemSummary(cart) {
    var drawer = getDrawer();
    var label = drawer && drawer.querySelector('[data-ids-item-summary]');
    if (!label || !cart || !Array.isArray(cart.items)) return;
    var products = 0;
    var gifts = 0;
    cart.items.forEach(function (item) {
      if (item.product_type === 'free_gift') gifts += item.quantity;
      else products += item.quantity;
    });
    var text = label.getAttribute(products === 1 ? 'data-item-one' : 'data-item-other') || '';
    text = text.replace('__COUNT__', String(products));
    if (gifts > 0) {
      var giftText = label.getAttribute(gifts === 1 ? 'data-gift-one' : 'data-gift-other') || '';
      text += ' + ' + giftText.replace('__COUNT__', String(gifts));
    }
    if (label.textContent !== text) label.textContent = text;
    label.hidden = products + gifts === 0;
  }

  function applyCartState(cart) {
    syncDrawerItemSummary(cart);
    syncCartGoals(cart);
    syncCouponState(cart);
    enforceGiftRules(cart);
    var count = cart.item_count;
    var d = getDrawer();
    ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.cart__count',
     '.header__cart-count', '[data-header-cart-count]', '.js-cart-count', '#cart-count'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        var countLabel = d && d.getAttribute('data-cart-count-label');
        if(countLabel) el.setAttribute('aria-label',countLabel.replace('__COUNT__',String(count)));
        if (count > 0) el.removeAttribute('hidden');
      });
    });
    var ev = new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, source: 'ids-cart-extras' } });
    document.dispatchEvent(ev);
    return cart;
  }

  function syncHeader(cartState) {
    var statePromise = cartState && typeof cartState.item_count === 'number'
      ? Promise.resolve(cartState)
      : fetch(cartStateUrl()).then(function (r) { return r.json(); });

    return statePromise
      .then(function (cart) {
        return applyCartState(cart);
      })
      .catch(function () {});
  }

  /* ───────── הוספה מהירה מעמוד מוצר ─────────
     תגובת cart/add.js כבר כוללת את סקשן הסל המעודכן. הסקשן נושא את
     מספר הפריטים והסכומים ב-data attributes, ולכן אין צורך להמתין
     לבקשת /cart נוספת לפני פתיחת המגירה. אם הסקשן או הנתונים חסרים,
     נשמרת התנהגות התבנית המקורית באמצעות fallback מלא ל-/cart. */

  function serializedCartState(root, sections) {
    var node = root.querySelector('[data-ids-cart-state]');
    if (!node) return null;
    try {
      var cart = JSON.parse(node.textContent);
      if (!cart || !Array.isArray(cart.items) ||
          typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') return null;
      cart.sections = sections;
      return cart;
    } catch (_) { return null; }
  }

  function cartStateFromBundledSections(sections) {
    if (!sections || typeof sections !== 'object') return null;

    var keys = Object.keys(sections);
    for (var i = 0; i < keys.length; i += 1) {
      var html = sections[keys[i]];
      if (typeof html !== 'string' || html.indexOf('<cart-drawer') === -1) continue;

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fullState = serializedCartState(doc, sections);
      if (fullState) return fullState;
      var drawer = doc.querySelector('cart-drawer[data-cart-item-count]');
      if (!drawer) continue;

      var itemCount = Number(drawer.getAttribute('data-cart-item-count'));
      var itemsSubtotal = Number(drawer.getAttribute('data-cart-items-subtotal-price'));
      var totalPrice = Number(drawer.getAttribute('data-cart-total-price'));

      if (!Number.isFinite(itemCount) || !Number.isFinite(itemsSubtotal) || !Number.isFinite(totalPrice)) {
        continue;
      }

      return {
        sections: sections,
        item_count: itemCount,
        items_subtotal_price: itemsSubtotal,
        total_price: totalPrice
      };
    }

    return null;
  }

  function fastProductFormSubmission(config) {
    var form = this;

    fetch(String(FoxTheme.routes.cart_add_url), config)
      .then(function (response) { return response.json(); })
      .then(function (product) {
        if (product.status) {
          form.handleCartError(product);
          return null;
        }

        var bundledState = cartStateFromBundledSections(product.sections);
        var cartPromise = bundledState
          ? Promise.resolve(bundledState)
          : fetch(String(FoxTheme.routes.cart_url), FoxTheme.utils.fetchConfig())
              .then(function (response) { return response.json(); })
              .then(function (cart) {
                cart.sections = product.sections;
                return cart;
              });

        return cartPromise.then(function (cart) {
          form.updateCartState(cart);
          form.dispatchProductAddedEvent(product);
          form.showCartDrawer();
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        form.submitButtonElement.classList.remove('btn--loading');
        form.submitButtonElement.removeAttribute('aria-disabled');
        if (!form.hasError) form.submitButtonElement.removeAttribute('aria-disabled');
      });
  }

  function patchProductForm(form) {
    if (!form || form.getAttribute('is') !== 'product-form') return;
    if (form.getAttribute('data-ids-fast-cart') === '1') return;
    if (typeof form.handleFormSubmission !== 'function') return;

    form.setAttribute('data-ids-fast-cart', '1');
    form.handleFormSubmission = fastProductFormSubmission;
  }

  function patchProductForms() {
    document.querySelectorAll('form[is="product-form"]').forEach(patchProductForm);
  }

  /* Quick view ובלוקים דינמיים יכולים ליצור את הטופס רק ברגע הלחיצה.
     Capture מבטיח שהטופס יתוקן לפני שמאזין ה-submit של התבנית רץ. */
  document.addEventListener('submit', function (event) {
    patchProductForm(event.target);
  }, true);

  /* ───────── מתנות ───────── */

  var giftRequestBusy = false;

  function addGift(btn, variantId) {
    var widget = btn.closest('[data-ids-gift]');
    var drawer = getDrawer();
    if (!widget || !drawer || giftRequestBusy || btn.disabled || drawer.classList.contains('ids-busy')) return;
    var state = widget.getAttribute('data-state');
    if (state !== 'choose' && state !== 'chosen') return;
    var changeBtn = widget.querySelector('[data-ids-gift-change]');
    var currentKey = changeBtn ? changeBtn.getAttribute('data-current-key') : null;
    var currentLine = changeBtn ? changeBtn.getAttribute('data-current-line') : null;
    var updates = {};
    if (currentKey) updates[currentKey] = 0;
    updates[String(variantId)] = 1;
    giftRequestBusy = true;
    btn.disabled = true;
    setBusy(btn, true);
    setDrawerBusy(true);
    var request = state === 'chosen' && !currentKey
      ? (currentLine ? cartChangeLine(currentLine, 0) : Promise.resolve())
          .then(function () { return cartAdd(variantId, 1); })
      : fetch(cartApiUrl('update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(withCartSection({ updates: updates }))
        }).then(function (r) {
          if (!r.ok) throw new Error('gift-update-failed');
          return r.json();
        });
    return request
      .then(function (cart) { return refreshDrawer(cart, { preserveGiftUpsell: true }); })
      .catch(function () {
        return refreshDrawer().then(function () {
          var currentWidget = getDrawer() && getDrawer().querySelector('[data-ids-gift]');
          if (!currentWidget) return;
          var message = currentWidget.querySelector('[data-ids-gift-error]');
          if (!message) {
            message = document.createElement('p');
            message.setAttribute('data-ids-gift-error', '');
            message.setAttribute('role', 'alert');
            message.className = 'ids-gift__note';
            currentWidget.appendChild(message);
          }
          message.textContent = 'לא הצלחנו לעדכן את המתנה. נסי שוב.';
        });
      })
      .finally(function () {
        giftRequestBusy = false;
        btn.disabled = false;
        setBusy(btn, false);
      });
  }

  /* פתיחת מצב בחירה במקום הכרטיס הנבחר */
  function openGiftSwap(btn) {
    var widget = btn.closest('[data-ids-gift]');
    if (!widget) return;
    var chosenRow = widget.querySelector('[data-ids-gift-chosen-row]');
    var list = widget.querySelector('.ids-gift__list--swap');
    var headChosen = widget.querySelector('[data-ids-gift-head-chosen]');
    var headChoose = widget.querySelector('[data-ids-gift-head-choose]');
    if (chosenRow) chosenRow.setAttribute('hidden', '');
    if (list) list.removeAttribute('hidden');
    if (headChosen) headChosen.setAttribute('hidden', '');
    if (headChoose) headChoose.removeAttribute('hidden');
    /* v22: מצב-פוקוס — מעמעם את שאר הסל, המתנות בפוקוס */
    var d = getDrawer();
    if (d) d.classList.add('ids-gift-swap-open');
  }

  /* חזרה מהבחירה לכרטיס הנבחר — בלי שינוי בסל */
  function closeGiftSwap(btn) {
    var widget = btn.closest('[data-ids-gift]');
    if (!widget) return;
    var chosenRow = widget.querySelector('[data-ids-gift-chosen-row]');
    var list = widget.querySelector('.ids-gift__list--swap');
    var headChosen = widget.querySelector('[data-ids-gift-head-chosen]');
    var headChoose = widget.querySelector('[data-ids-gift-head-choose]');
    if (list) list.setAttribute('hidden', '');
    if (chosenRow) chosenRow.removeAttribute('hidden');
    if (headChoose) headChoose.setAttribute('hidden', '');
    if (headChosen) headChosen.removeAttribute('hidden');
    /* v22: יציאה ממצב-פוקוס */
    var d = getDrawer();
    if (d) d.classList.remove('ids-gift-swap-open');
  }

  function swapGift(btn, newVariantId) {
    return addGift(btn, newVariantId);
  }

  /* מתנה יתומה — הסל ירד מתחת ליעד, מסירים אוטומטית */
  function handleOrphanGift() {
    var g = document.querySelector('[data-ids-gift][data-state="orphan"]');
    if (!g || giftGuardBusy || g.getAttribute('data-ids-busy') === '1') return;
    var key = g.getAttribute('data-orphan-key');
    if (!key) return;
    g.setAttribute('data-ids-busy', '1');
    setDrawerBusy(true);
    var updates = {};
    updates[key] = 0;
    fetch(cartApiUrl('update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withCartSection({ updates: updates }))
    })
      .then(function (r) { if (!r.ok) throw new Error('gift-update-failed'); return r.json(); })
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── החלפת מידה בשורת פריט ───────── */

  function swapLineVariant(sel) {
    var line = sel.getAttribute('data-line');
    var item = sel.closest('.cart-item');
    var qty = item ? Number(item.getAttribute('data-quantity')) || 1 : 1;
    var newId = sel.value;
    sel.disabled = true;
    setDrawerBusy(true);
    cartChangeLine(line, 0, { render: false })
      .then(function () { return cartAdd(newId, qty); })
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───────── קופון ───────── */

  function toggleCoupon(btn) {
    var wrap = btn.closest('[data-ids-coupon]');
    var form = wrap ? wrap.querySelector('.ids-coupon__form') : null;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (form) {
      if (open) form.setAttribute('hidden', '');
      else {
        form.removeAttribute('hidden');
        /* פוקוס אוטומטי רק בדסקטופ — במובייל זה מקפיץ מקלדת מיד */
        var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        var input = form.querySelector('[data-ids-coupon-input]');
        if (input && fine) input.focus();
      }
    }
  }

  function showCouponMsg(wrap, text, ok) {
    var msg = wrap ? wrap.querySelector('[data-ids-coupon-msg]') : null;
    if (!msg) return;
    msg.textContent = text;
    msg.classList.remove('is-ok', 'is-error');
    msg.classList.add(ok ? 'is-ok' : 'is-error');
    msg.removeAttribute('hidden');
  }

  var couponRequestBusy = false;

  function couponCodes(cart) {
    if (!cart) return [];
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.filter(function (entry) {
        return entry.applicable === true && typeof entry.code === 'string';
      }).map(function (entry) { return entry.code; });
    }
    var applications = (cart.cart_level_discount_applications || []).concat(cart.discount_applications || []);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    var codes = [];
    applications.forEach(function (application) {
      var code = application && application.type === 'discount_code' && application.title;
      if (code && !codes.some(function (existing) { return existing.toUpperCase() === code.toUpperCase(); })) codes.push(code);
    });
    return codes;
  }

  /* IDS 3.11.2026: סכום ההנחה של כל קוד (בלי הנחת משלוח) — אותו total_allocated_amount מופיע גם ברמת הסל וגם בכל שורה, לכן לוקחים פעם אחת לפי שם הקוד.
     בתשובה של הבקשה שמחילה את הקוד שופיפיי מחזירה ברמת הסל {amount, discount_application} במקום את האפליקציה עצמה — שני המבנים נתמכים */
  function couponGains(cart) {
    var gains = {};
    function note(app) {
      if (app && app.discount_application) app = app.discount_application;
      if (!app || app.type !== 'discount_code' || app.target_type === 'shipping_line' || !app.title) return;
      var key = String(app.title).toUpperCase();
      gains[key] = Math.max(gains[key] || 0, Number(app.total_allocated_amount) || 0);
    }
    (cart.cart_level_discount_applications || []).forEach(note);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) { note(allocation.discount_application); });
    });
    return gains;
  }

  function syncCouponState(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return;
    var drawer = getDrawer();
    var wrap = drawer && drawer.querySelector('[data-ids-coupon]');
    var list = wrap && wrap.querySelector('[data-ids-coupon-codes]');
    if (!list) return;
    var codes = couponCodes(cart);
    var gains = couponGains(cart);
    var label = wrap.getAttribute('data-remove-label') || '';
    list.innerHTML = codes.map(function (code) {
      var gain = gains[code.toUpperCase()] || 0;
      /* אותו פורמט כמו money_without_trailing_zeros בשורה הראשונית של Liquid ("29 ₪"), כדי שהצ'יפ לא יתחלף אחרי פעולה בסל */
      var gainTxt = (Math.round(gain) / 100).toFixed(2).replace(/\.00$/, '') + ' ₪';
      return '<li><bdi>' + esc(code) + '</bdi>' + (gain > 0 ? '<span class="ids-coupon__gain">· <bdi>' + gainTxt + '</bdi> הנחה</span>' : '') + '<button type="button" class="ids-coupon__remove" data-ids-coupon-remove="' + esc(code) + '" aria-label="' + esc(label + ' ' + code) + '"><span aria-hidden="true">×</span></button></li>';
    }).join('');
    list.hidden = !codes.length;
  }

  function couponResult(code, ok) {
    var drawer = getDrawer();
    var wrap = drawer && drawer.querySelector('[data-ids-coupon]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-ids-coupon-input]');
    var form = wrap.querySelector('[data-ids-coupon-form]');
    var toggle = wrap.querySelector('[data-ids-coupon-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', ok ? 'false' : 'true');
    if (form) form.hidden = ok;
    if (input) {
      input.value = ok ? '' : code;
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }
    showCouponMsg(wrap, wrap.getAttribute(ok ? 'data-success' : 'data-invalid'), ok);
    if (toggle && ok) toggle.focus({ preventScroll: true });
  }

  function applyCoupon(btn) {
    var drawer = getDrawer();
    if (couponRequestBusy || !drawer || drawer.classList.contains('ids-busy')) return;
    var wrap = btn.closest('[data-ids-coupon]');
    var input = wrap ? wrap.querySelector('[data-ids-coupon-input]') : null;
    var code = input ? (input.value || '').trim() : '';
    if (!code) {
      showCouponMsg(wrap, wrap.getAttribute('data-empty'), false);
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return;
    }
    couponRequestBusy = true;
    setBusy(btn, true);
    btn.disabled = true;
    setDrawerBusy(true);
    if (input) input.removeAttribute('aria-invalid');

    return fetch(cartApiUrl('update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withCartSection({ discount: code }))
    })
      .then(function (response) {
        if (!response.ok) throw new Error('coupon-update-failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error('invalid-cart-response');
        var applied = couponCodes(cart).some(function (entry) { return entry.toUpperCase() === code.toUpperCase(); });
        if (!applied && !Array.isArray(cart.discount_codes)) {
          var html = cart.sections && cart.sections[getSectionId()];
          if (typeof html === 'string') {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            applied = Array.from(doc.querySelectorAll('[data-ids-coupon-codes] [data-ids-coupon-remove]')).some(function (button) {
              return button.getAttribute('data-ids-coupon-remove').toUpperCase() === code.toUpperCase();
            });
          }
        }
        if (!applied) checkoutQueued = false;
        return refreshDrawer(cart).then(function () { couponResult(code, applied); });
      })
      .catch(function () {
        checkoutQueued = false;
        var current = getDrawer();
        var currentWrap = current && current.querySelector('[data-ids-coupon]');
        if (currentWrap) showCouponMsg(currentWrap, currentWrap.getAttribute('data-error'), false);
      })
      .finally(function () {
        couponRequestBusy = false;
        btn.disabled = false;
        setBusy(btn, false);
        setDrawerBusy(false);
        if (!checkoutQueued && !checkoutSubmitting) {
          var current = getDrawer();
          setCheckoutPending(current && current.querySelector('[data-ids-checkout-form]'), false);
        }
      });
  }

  function removeCoupon(btn) {
    var drawer = getDrawer();
    if (couponRequestBusy || !drawer || drawer.classList.contains('ids-busy')) return;
    var code = btn.getAttribute('data-ids-coupon-remove');
    if (!code) return;
    couponRequestBusy = true;
    setBusy(btn, true);
    btn.disabled = true;
    setDrawerBusy(true);
    var remaining = [];
    drawer.querySelectorAll('[data-ids-coupon-codes] [data-ids-coupon-remove]').forEach(function (entry) {
      var existing = entry.getAttribute('data-ids-coupon-remove');
      if (existing && existing.toUpperCase() !== code.toUpperCase() &&
          !remaining.some(function (value) { return value.toUpperCase() === existing.toUpperCase(); })) remaining.push(existing);
    });
    return fetch(cartApiUrl('update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withCartSection({ discount: remaining.join(',') }))
    })
      .then(function (response) {
        if (!response.ok) throw new Error('coupon-update-failed');
        return response.json();
      })
      .then(refreshDrawer)
      .catch(function () {
        checkoutQueued = false;
        var current = getDrawer();
        var wrap = current && current.querySelector('[data-ids-coupon]');
        if (wrap) showCouponMsg(wrap, wrap.getAttribute('data-error'), false);
      })
      .finally(function () {
        couponRequestBusy = false;
        btn.disabled = false;
        setBusy(btn, false);
        setDrawerBusy(false);
        if (!checkoutQueued && !checkoutSubmitting) {
          var current = getDrawer();
          setCheckoutPending(current && current.querySelector('[data-ids-checkout-form]'), false);
        }
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('[data-ids-coupon-form]')) return;
    event.preventDefault();
    var button = form.querySelector('[data-ids-coupon-apply]');
    if (button) applyCoupon(button);
  });

  /* ───────── תקנון — שער לפני תשלום (רעידה + אדום בלבד) ───────── */

  /* v14: מפתח השמירה ב-sessionStorage — היה חסר וגרם לשגיאת קונסול */
  var TERMS_KEY = 'ids-terms-ok';

  function onTermsChange(box) {
    try {
      if (box.checked) sessionStorage.setItem(TERMS_KEY, '1');
      else sessionStorage.removeItem(TERMS_KEY);
    } catch (_) {}
    var wrap = box.closest('[data-ids-terms]');
    if (wrap) wrap.classList.remove('is-invalid');
  }

  function setCheckoutPending(form, on) {
    if (!form) return;
    var button = form.querySelector('[name="checkout"]');
    if (!button) return;
    button.classList[on ? 'add' : 'remove']('btn--loading');
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  function flushQueuedCheckout() {
    if (!checkoutQueued || checkoutSubmitting) return;
    window.requestAnimationFrame(function () {
      if (!checkoutQueued || checkoutSubmitting) return;
      var drawer = getDrawer();
      if (!drawer || drawer.classList.contains('ids-busy')) return;
      var form = drawer.querySelector('[data-ids-checkout-form]');
      var button = form ? form.querySelector('[name="checkout"]') : null;
      if (!form || !button) return;

      checkoutQueued = false;
      setCheckoutPending(form, false);
      if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
      else button.click();
    });
  }

  function guardCheckout(e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-ids-checkout-form]') : null;
    if (!form) return;
    var drawer = form.closest('cart-drawer');
    var orphan = drawer && drawer.querySelector('[data-ids-gift][data-state="orphan"]');
    if (orphan) handleOrphanGift();
    if (orphan || (drawer && drawer.classList.contains('ids-busy'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      checkoutQueued = true;
      setCheckoutPending(form, true);
      return;
    }
    var box = document.querySelector('[data-ids-terms-box]');
    if (box && !box.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var wrap = box.closest('[data-ids-terms]');
      if (wrap) {
        wrap.classList.remove('is-invalid');
        void wrap.offsetWidth;
        wrap.classList.add('is-invalid');
        wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }
    if (checkoutSubmitting) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    checkoutSubmitting = true;
    setCheckoutPending(form, true);
  }

  document.addEventListener('submit', guardCheckout, true);

  /* ───────── אפסייל: השלימי את הלוק (v15/v16 — קרוסלה חכמת-מידות) ───────── */

  function filterRecs(products, exclude) {
    return (products || []).filter(function (p) {
      return p.available && p.type !== 'free_gift' && exclude.indexOf(String(p.id)) === -1;
    });
  }

  /* ───── v15: התאמת מידות ─────
     המידות שכבר בסל מגיעות מהסקשן ב-data-cart-sizes.
     מוצר "מתאים" = יש לו וריאנט זמין במלאי באחת מהמידות האלה.
     מוצר בלי אופציית מידה בכלל (אקססורי, One Size בשם אחר) —
     נחשב מתאים תמיד. */

  function normSize(s) {
    return String(s == null ? '' : s).trim().toUpperCase();
  }

  function getCartSizes(box) {
    return (box.getAttribute('data-cart-sizes') || '')
      .split(',').map(normSize).filter(Boolean);
  }

  var SIZE_OPTION_NAMES = ['מידה', 'מידות', 'גודל', 'SIZE', 'SIZES'];

  /* אינדקס אופציית המידה במוצר; ‎-1 אם אין. תומך בשני פורמטים
     של options בתשובת ה-API: מערך מחרוזות או מערך אובייקטים. */
  function sizeOptionIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var name = typeof o === 'string' ? o : (o && o.name);
      if (name && SIZE_OPTION_NAMES.indexOf(normSize(name)) > -1) {
        if (o && typeof o === 'object' && o.position) return o.position - 1;
        return i;
      }
    }
    return -1;
  }

  function variantSize(v, idx) {
    if (v.options && v.options.length) return normSize(v.options[idx]);
    return normSize(v['option' + (idx + 1)]);
  }

  function matchesCartSizes(p, cartSizes) {
    var variants = (p.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) return false;
    var idx = sizeOptionIndex(p);
    if (idx < 0) return variants.length === 1;
    var oneSizes = ['ONE SIZE', 'ONESIZE', 'ONE-SIZE', 'OS', 'O/S'];
    if (variants.length === 1 && oneSizes.indexOf(variantSize(variants[0], idx)) > -1) return true;
    if (!cartSizes.length) return false;
    return variants.some(function (v) {
      return cartSizes.indexOf(variantSize(v, idx)) > -1;
    });
  }

  /* ───── v21: התאמת מידה לפי סוג פריט — עליון/תחתון ─────
     טופ M + טייץ S בסל → לטייץ מומלץ נשאבת S (מהטייץ), לא M (מהטופ).
     המידות נקראות ישירות משורות הסל שב-DOM: שם המוצר קובע את הסוג,
     והמידה נלקחת מהבורר של אותה שורה. אין פריט מאותו סוג בסל —
     נסיגה לרשימה הכללית (ההתנהגות הקודמת). */
  function garmentKind(title) {
    var t = String(title || '');
    var bottomKeys = ['טייץ', 'שורט', 'מכנס'];
    var topKeys = ['טופ', 'גופי', 'חולצ', 'קרופ', "ג'קט", 'ז׳קט', 'סווט', 'סווצ'];
    var isB = bottomKeys.some(function (k) { return t.indexOf(k) > -1; });
    var isT = topKeys.some(function (k) { return t.indexOf(k) > -1; });
    if (isB && !isT) return 'bottom';
    if (isT && !isB) return 'top';
    return '';
  }

  function cartSizesByKind() {
    var out = { top: [], bottom: [], all: [] };
    var items = document.querySelectorAll('#CartDrawer .cart-item');
    [].forEach.call(items, function (li) {
      var titleEl = li.querySelector('.cart-item__title');
      var sel = li.querySelector('[data-ids-line-variant]');
      if (!sel) return; /* מוצר בלי מידות (אקססורי) */
      var opt = sel.options[sel.selectedIndex];
      var size = normSize((opt ? opt.textContent : '').split('—')[0]);
      if (!size) return;
      var kind = garmentKind(titleEl ? titleEl.textContent : '');
      if (out.all.indexOf(size) === -1) out.all.push(size);
      if (kind && out[kind].indexOf(size) === -1) out[kind].push(size);
    });
    return out;
  }

  function sizesForProduct(p, byKind, fallback) {
    var kind = garmentKind(p && p.title);
    if (kind && byKind[kind] && byKind[kind].length) return byKind[kind];
    if (byKind.all.length) return byKind.all;
    return fallback || [];
  }

  function fetchRecs(pid, intent) {
    var key = String(pid) + ':' + String(intent);
    if (Object.prototype.hasOwnProperty.call(recommendationsCache, key)) {
      return Promise.resolve(recommendationsCache[key]);
    }
    if (recommendationRequests[key]) return recommendationRequests[key];

    recommendationRequests[key] = fetch(
      rootUrl() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent
    )
      .then(function (r) {
        if (!r.ok) throw new Error('recommendations-unavailable');
        return r.json();
      })
      .then(function (d) {
        var products = Array.isArray(d.products) ? d.products : [];
        recommendationsCache[key] = products;
        return products;
      })
      .catch(function () { return []; })
      .then(function (products) {
        delete recommendationRequests[key];
        return products;
      });

    return recommendationRequests[key];
  }

  function loadUpsell() {
    var box = document.querySelector('[data-ids-upsell]');
    if (!box || box.getAttribute('data-ids-loaded') === '1') return;
    box.setAttribute('data-ids-loaded', '1');
    var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var cartSizes = getCartSizes(box);
    var byKind = cartSizesByKind();
    var seen = {};
    var sources = Array.from(document.querySelectorAll('#CartDrawer .cart-item[data-product-id]'))
      .map(function (item) {
        return { id: item.getAttribute('data-product-id'), title: item.getAttribute('data-product-title') || '' };
      })
      .filter(function (item) {
        if (!item.id || seen[item.id]) return false;
        seen[item.id] = true;
        return true;
      });

    function findSuggestions(intent) {
      if (!box.isConnected) return Promise.resolve([]);
      return Promise.all(sources.map(function (source) {
        return fetchRecs(source.id, intent).then(function (products) {
          return filterRecs(products, exclude).filter(function (p) {
            return !p.gift_card && p.price > 0 &&
              matchesCartSizes(p, sizesForProduct(p, byKind, cartSizes));
          }).map(function (product) {
            return { product: product, source: source, intent: intent };
          });
        });
      })).then(function (groups) {
        return [].concat.apply([], groups);
      });
    }

    Promise.all([findSuggestions('complementary'), findSuggestions('related')])
      .then(function (groups) {
        if (!box.isConnected) return;
        var used = {};
        var matches = groups[0].concat(groups[1]).filter(function (match) {
          var id = String(match.product.id);
          if (used[id]) return false;
          used[id] = true;
          return true;
        }).slice(0, 5);
        if (!matches.length) return;
        var list = box.querySelector('[data-ids-upsell-list]');
        var label = box.querySelector('[data-ids-pair-label]');
        if (!list || !label) return;
        list.innerHTML = matches.map(function (match) {
          return renderUpsellItem(match.product, sizesForProduct(match.product, byKind, cartSizes));
        }).join('');
        matches.forEach(function (match, index) {
          var model = match.source.title.split(/\s+[-–—]\s+/)[0].trim();
          var caption = match.intent === 'complementary'
            ? 'עם ' + model
            : (box.getAttribute('data-more-label') || '');
          list.children[index].setAttribute('data-ids-slide-label', caption);
        });
        label.textContent = list.children[0].getAttribute('data-ids-slide-label');
        setupUpsellSwipe(box, list, matches.length);
        box.removeAttribute('hidden');
        requestAnimationFrame(function () { if (box.isConnected) box.classList.add('is-in'); });
      }).catch(function () {});
  }

  /* ───── v15: סוויפ — scroll-snap אופקי + נקודות ─────
     בלי ספריות: הרשימה הופכת למסילה אופקית עם הצצה לכרטיס הבא,
     נקודות מתעדכנות לפי הכרטיס הקרוב למרכז (עובד גם ב-RTL כי
     המדידה היא ב-getBoundingClientRect, לא ב-scrollLeft). */

  /* הכרטיס הקרוב ביותר למרכז המסילה */
  function nearestSlideIndex(list) {
    var slides = list.children;
    if (!slides.length) return 0;
    var lc = list.getBoundingClientRect();
    var center = lc.left + lc.width / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var dist = Math.abs(r.left + r.width / 2 - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }

  function setupUpsellSwipe(box, list, count) {
    var old = box.querySelector('.ids-upsell__dots');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (count < 2) { list.classList.remove('is-swipe'); return; }
    list.classList.add('is-swipe');

    /* v16: במה — עוטפת את המסילה כדי לעגן חיצים בדסקטופ */
    var stage = list.parentNode;
    if (!stage.classList || !stage.classList.contains('ids-upsell__stage')) {
      stage = document.createElement('div');
      stage.className = 'ids-upsell__stage';
      list.parentNode.insertBefore(stage, list);
      stage.appendChild(list);
    } else {
      var oldArrows = stage.querySelectorAll('.ids-upsell__arrow');
      for (var a = 0; a < oldArrows.length; a++) {
        oldArrows[a].parentNode.removeChild(oldArrows[a]);
      }
    }

    /* חיצים — RTL: הכרטיס הבא משמאל, "הקודם" מימין. דסקטופ בלבד (CSS) */
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ids-upsell__arrow ids-upsell__arrow--prev is-off';
    prev.setAttribute('data-ids-arrow', '-1');
    prev.setAttribute('aria-label', 'המוצר הקודם'); /* המוצר הקודם */
    prev.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l8 7-8 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ids-upsell__arrow ids-upsell__arrow--next';
    next.setAttribute('data-ids-arrow', '1');
    next.setAttribute('aria-label', 'המוצר הבא'); /* המוצר הבא */
    next.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-8 7 8 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    stage.appendChild(prev);
    stage.appendChild(next);

    var dots = document.createElement('div');
    dots.className = 'ids-upsell__dots';
    for (var i = 0; i < count; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ids-upsell__dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('data-ids-dot', String(i));
      d.setAttribute('aria-label', 'מוצר ' + (i + 1) + ' מתוך ' + count); /* מוצר X מתוך Y */
      dots.appendChild(d);
    }
    stage.parentNode.insertBefore(dots, stage.nextSibling);

    function syncNav() {
      var best = nearestSlideIndex(list);
      var label = box.querySelector('[data-ids-pair-label]');
      if (label) label.textContent = list.children[best].getAttribute('data-ids-slide-label') || '';
      var ds = dots.children;
      for (var j = 0; j < ds.length; j++) {
        ds[j].classList[j === best ? 'add' : 'remove']('is-active');
      }
      prev.classList[best === 0 ? 'add' : 'remove']('is-off');
      next.classList[best === count - 1 ? 'add' : 'remove']('is-off');
    }

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncNav(); });
    }, { passive: true });
  }

  function goToUpsellSlide(dotBtn) {
    var box = dotBtn.closest('[data-ids-upsell]');
    var list = box ? box.querySelector('[data-ids-upsell-list]') : null;
    if (!list) return;
    var idx = Number(dotBtn.getAttribute('data-ids-dot')) || 0;
    var slide = list.children[idx];
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  /* ───── v14: מצב-פער למשלוח חינם ─────
     חלון ההפעלה: חסר עד ₪60 ליעד המשלוח (נגזר מ-data-goal-ship
     של הסקשן — לא קשיח בקוד). הכותרת מתחלפת למיקרו-קופי עם
     הסכום החסר רק אם הפס מציג בפועל פריט שסוגר את הפער במחיר
     סביר (עד ₪200). אין פריט כזה או שהסל מעל היעד — הכותרת
     הרגילה נשארת, בלי UI שבור. החזרה למצב רגיל אוטומטית —
     הסקשן מתרנדר מחדש מהשרת אחרי כל שינוי בסל. */
  var GAP_WINDOW = 6000;      /* ₪60 באגורות — רוחב חלון ההפעלה */
  var GAP_MAX_FILLER = 20000; /* ₪200 באגורות — תקרת משלים זול */

  function shipGap(box) {
    var total = Number(box.getAttribute('data-cart-total')) || 0;
    var gShip = Number(box.getAttribute('data-goal-ship')) || 0;
    var gap = gShip - total;
    return gShip && gap > 0 && gap <= GAP_WINDOW ? gap : 0; /* באגורות */
  }

  function maybeSwapUpsellHead(box, prods) {
    var gap = shipGap(box);
    if (!gap) return; /* מחוץ לחלון — התנהגות רגילה */
    var hasCloser = (prods || []).some(function (p) {
      return p.price >= gap && p.price <= GAP_MAX_FILLER;
    });
    if (!hasCloser) return; /* אין משלים מתאים בפול — התנהגות רגילה */
    var head = box.querySelector('.ids-upsell__head');
    if (!head) return; /* אין כותרת בהגדרות הסקשן — לא נוגעים */
    head.style.fontWeight = '500'; /* משקל 500 — בלי הדגשה כבדה */
    head.innerHTML = 'עוד ' + /* עוד */
      '<b style="color:var(--ids-green,#157f4c)">' + money(gap) + '</b>' + /* ₪X */
      ' למשלוח חינם — אפשר להשלים עם אחד מאלה:'; /* למשלוח חינם — אפשר להשלים עם אחד מאלה */
  }

  /* חכם-פערים: אם חסר סכום ליעד הבא, מקדימים את המוצר הזול
     ביותר שמחירו סוגר את הפער (היעד מושג בפריט אחד). אם אף
     מוצר לא סוגר — הקרוב ביותר. בלי יעד פתוח: הסדר המקורי.
     v16: מופעל רק בחלון פער-המשלוח (ראו loadUpsell). */
  function smartOrder(prods, box) {
    if (!prods || prods.length < 2) return prods || [];
    var total = Number(box.getAttribute('data-cart-total')) || 0;
    var gGift = Number(box.getAttribute('data-goal-gift')) || 0;
    var gShip = Number(box.getAttribute('data-goal-ship')) || 0;
    var gap = 0;
    var giftTotal = Number(box.getAttribute('data-gift-eligible-total')) || 0;
    if (gGift && giftTotal < gGift) gap = gGift - giftTotal;
    else if (gShip && total < gShip) gap = gShip - total;
    if (gap <= 0) return prods;
    var closing = prods.filter(function (p) { return p.price >= gap; });
    var rest = prods.filter(function (p) { return p.price < gap; });
    closing.sort(function (a, b) { return a.price - b.price; });
    rest.sort(function (a, b) { return b.price - a.price; });
    return closing.concat(rest);
  }

  /* v17: כרטיס אפסייל עם כפתורי מידה (pills) —
     המידה שכבר בסל נבחרת מראש, כך ש"הוספה" תמיד עובדת בלחיצה
     אחת. אזלה המידה מהסל? נבחרת הזמינה הראשונה. תמיד יש בחירה. */
  function renderUpsellItem(p, cartSizes) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var variants = p.variants || [];
    var availList = variants.filter(function (v) { return v.available; });
    var first = availList[0] || variants[0] || null;
    var hasVars = variants.length > 1;
    var pillsHtml = '';
    var defVariant = null;
    if (hasVars) {
      var idx = sizeOptionIndex(p);
      /* ברירת מחדל חכמה: המידה שכבר בסל (לפי סדר הפריטים), אם זמינה */
      if (idx > -1 && cartSizes && cartSizes.length) {
        for (var s = 0; s < cartSizes.length && !defVariant; s++) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].available && variantSize(variants[i], idx) === cartSizes[s]) {
              defVariant = variants[i];
              break;
            }
          }
        }
      }
      if (!defVariant) defVariant = first;
      /* v18: שורה שקטה עם המידה הנבחרת + כפתורי מידות מוסתרים
         (progressive disclosure). רק מידות שבמלאי מוצגות. */
      var defLabel = defVariant ? (idx > -1 ? variantSize(defVariant, idx) : defVariant.title) : '';
      pillsHtml = '<button type="button" class="ids-upsell__sizechip" data-ids-upsell-chip>' +
          'מידה <b>' + esc(defLabel) + '</b> · <u>שינוי</u>' + /* מידה X · שינוי */
        '</button>' +
        '<div class="ids-upsell__sizes" data-ids-upsell-sizes hidden role="group" aria-label="בחירת מידה — ' + esc(p.title) + '">' + /* בחירת מידה */
        availList.map(function (v) {
          var label = idx > -1 ? variantSize(v, idx) : v.title;
          return '<button type="button" class="ids-upsell__size' +
            (defVariant && v.id === defVariant.id ? ' is-selected' : '') + '"' +
            ' data-ids-upsell-size data-variant-id="' + v.id + '"' +
            ' data-size-label="' + esc(label) + '"' +
            ' aria-label="מידה ' + esc(label) + '"' + /* מידה X */
            '>' + esc(label) + '</button>';
        }).join('') +
      '</div>';
    }
    var addId = hasVars ? (defVariant ? defVariant.id : '') : (first ? first.id : '');
    return '<div class="ids-upsell__item" dir="rtl" data-handle="' + esc(p.handle || '') + '">' +
      (img ? '<img class="ids-upsell__img" loading="lazy" src="' + esc(imgUrl(img, 120)) + '" alt="' + esc(p.title) + '">' : '') +
      '<div class="ids-upsell__info">' +
        '<span class="ids-upsell__title">' + esc(p.title) + '</span>' +
        '<span class="ids-upsell__price">' + priceHtml(p) + '</span>' +
        pillsHtml +
      '</div>' +
      '<button type="button" class="ids-upsell__add" data-ids-upsell-add' +
        (addId ? ' data-variant="' + addId + '"' : '') +
      '>הוספה</button>' + /* הוספה */
    '</div>';
  }

  function addUpsell(btn) {
    var variantId = btn.getAttribute('data-variant');
    var sel = null;
    if (!variantId) {
      var item = btn.closest('.ids-upsell__item');
      sel = item ? item.querySelector('[data-ids-upsell-variant]') : null;
      variantId = sel ? sel.value : null;
    }
    if (!variantId) {
      /* לא נבחרה מידה — מסמנים את הבורר במקום להוסיף מידה אקראית */
      if (sel) {
        sel.classList.remove('ids-sel-invalid');
        void sel.offsetWidth; /* ריסטרט לאנימציה */
        sel.classList.add('ids-sel-invalid');
        try { sel.focus({ preventScroll: true }); } catch (_) {}
      }
      return;
    }
    setBusy(btn, true);
    setDrawerBusy(true);
    cartAdd(variantId, 1)
      .then(refreshDrawer)
      .catch(function () { refreshDrawer(); });
  }

  /* ───── v19/v20: הצצת מוצר בתוך הסל ─────
     חלון קטן ממורכז עם רקע מעומעם, בתוך המגירה (לא מודאל מעל
     האתר) — נפתח בהקשה על תמונה/שם בכרטיס האפסייל. */

  var peekCache = {};

  /* מיפוי משפחת מוצר → עמוד טבלת המידות שלה.
     קל לעדכון: מוסיפים שורה לכל טבלה חדשה. אין התאמה — האקורדיון
     פשוט לא מוצג. */
  function sizeChartHandle(p) {
    var t = (p.title || '') + ' ' + (p.type || p.product_type || '');
    var up = t.toUpperCase();
    var isLeg = t.indexOf('טייץ') > -1;
    var isShort = t.indexOf('שורט') > -1;
    var isCrop = t.indexOf('קרופ') > -1;
    var isShirt = t.indexOf('חולצה') > -1;
    var isTop = t.indexOf('טופ') > -1 || t.indexOf('גופיי') > -1;
    if (up.indexOf('VENUS') > -1 && isLeg) return 'venus-highwaist-size-chart';
    if (isCrop) return 'hera-crop-top-size-chart';
    if (isShirt) return 'dragon-shirt-size-chart';
    if (isLeg) return 'aura-leggings-size-chart';
    if (isShort) return 'aura-shorts-size-chart';
    if (isTop) return 'aura-top-size-chart';
    return '';
  }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function closePeek() {
    var p = document.querySelector('.ids-peek');
    if (p && p.parentNode) p.parentNode.removeChild(p);
    /* v21: שחרור עמעום התוכן — אותו מנגנון כמו ids-busy */
    var d = getDrawer();
    if (d) d.classList.remove('ids-peek-open');
  }

  function openPeek(handle, presetVariantId) {
    if (!handle) return;
    var inner = document.querySelector('.cart-drawer .drawer__inner');
    if (!inner) return;
    closePeek();
    /* v21: עמעום התוכן עצמו — עובד בכל מצב גלילה ומבנה, כמו ids-busy */
    var dd = getDrawer();
    if (dd) dd.classList.add('ids-peek-open');
    var wrap = document.createElement('div');
    wrap.className = 'ids-peek';
    wrap.setAttribute('dir', 'rtl');
    wrap.innerHTML =
      '<div class="ids-peek__overlay" data-ids-peek-close></div>' +
      '<div class="ids-peek__card">' +
        '<button type="button" class="ids-peek__close" data-ids-peek-close aria-label="סגירה">' + /* סגירה */
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="ids-peek__body"><div class="ids-peek__loading">רק רגע…</div></div>' + /* רק רגע */
      '</div>';
    inner.appendChild(wrap);
    function render(p) {
      var body = wrap.querySelector('.ids-peek__body');
      if (body) body.innerHTML = peekHtml(p, presetVariantId);
    }
    if (peekCache[handle]) { render(peekCache[handle]); return; }
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { peekCache[handle] = p; render(p); })
      .catch(closePeek);
  }

  function peekHtml(p, presetVariantId) {
    var imgs = (p.images || []).slice(0, 5);
    var idx = sizeOptionIndex(p);
    var variants = p.variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    var def = null;
    if (presetVariantId) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(presetVariantId)) { def = variants[i]; break; }
      }
    }
    if (!def || !def.available) def = avail[0] || variants[0] || null;

    var gal = '';
    if (imgs.length) {
      gal = '<div class="ids-upsell__stage ids-peek__stage">' +
        '<div class="ids-peek__gallery' + (imgs.length > 1 ? ' is-swipe' : '') + '">' +
        imgs.map(function (u) {
          return '<div class="ids-peek__slide"><img loading="lazy" src="' + esc(imgUrl(u, 640)) + '" alt="' + esc(p.title) + '"></div>';
        }).join('') +
        '</div>' +
        (imgs.length > 1
          ? '<button type="button" class="ids-upsell__arrow ids-upsell__arrow--prev" data-ids-arrow="-1" aria-label="התמונה הקודמת"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l8 7-8 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            '<button type="button" class="ids-upsell__arrow ids-upsell__arrow--next" data-ids-arrow="1" aria-label="התמונה הבאה"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-8 7 8 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
          : '') +
      '</div>';
    }

    var pills = '';
    if (variants.length > 1) {
      pills = '<div class="ids-upsell__sizes ids-peek__sizes" role="group" aria-label="בחירת מידה — ' + esc(p.title) + '">' + /* בחירת מידה */
        avail.map(function (v) {
          var label = idx > -1 ? variantSize(v, idx) : v.title;
          return '<button type="button" class="ids-upsell__size' +
            (def && v.id === def.id ? ' is-selected' : '') + '"' +
            ' data-ids-peek-size data-variant-id="' + v.id + '">' + esc(label) + '</button>';
        }).join('') +
      '</div>';
    }

    var descr = stripHtml(p.description);
    if (descr.length > 240) descr = descr.slice(0, 240) + '…';
    var chartHandle = sizeChartHandle(p);

    return gal +
      '<div class="ids-peek__title">' + esc(p.title) + '</div>' +
      '<div class="ids-peek__price">' + priceHtml(p) + '</div>' +
      pills +
      '<button type="button" class="ids-peek__add" data-ids-peek-add' +
        (def ? ' data-variant="' + def.id + '"' : '') + '>הוספה לסל</button>' + /* הוספה לסל */
      '<div class="ids-peek__trust">יושב לפי המידה · החלפות פשוטות עד 14 יום</div>' + /* שורת ביטחון */
      (descr ? '<p class="ids-peek__desc">' + esc(descr) + '</p>' : '') +
      (chartHandle
        ? '<div class="ids-peek__chart">' +
            '<button type="button" class="ids-peek__chart-toggle" data-ids-peek-chart="' + chartHandle + '" aria-expanded="false">טבלת מידות</button>' + /* טבלת מידות */
            '<div class="ids-peek__chart-body" hidden></div>' +
          '</div>'
        : '');
  }

  /* טבלת מידות — נטענת פעם אחת מעמוד הטבלה של המשפחה */
  function toggleSizeChart(btn) {
    var body = btn.parentNode ? btn.parentNode.querySelector('.ids-peek__chart-body') : null;
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    if (open) {
      body.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
      return;
    }
    btn.setAttribute('aria-expanded', 'true');
    body.removeAttribute('hidden');
    if (body.getAttribute('data-loaded') === '1') return;
    body.innerHTML = 'טוענת את הטבלה…'; /* טוענת את הטבלה */
    fetch('/pages/' + encodeURIComponent(btn.getAttribute('data-ids-peek-chart')))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        /* v20: .page__content — גוף העמוד בתבנית main-page של התמה.
           הסלקטור הגנרי .rte תפס בטעות את פס ההכרזה. */
        var content = doc.querySelector('.page__content') ||
          doc.querySelector('main .rte') ||
          doc.querySelector('main');
        body.innerHTML = content ? content.innerHTML : 'הטבלה המלאה נמצאת בעמוד המוצר'; /* fallback */
        body.setAttribute('data-loaded', '1');
      })
      .catch(function () {
        body.innerHTML = 'הטבלה המלאה נמצאת בעמוד המוצר';
      });
  }

  /* ───────── האזנות — delegation, שורד כל רינדור-מחדש ───────── */

  /* ───────── פותחן ביטחון ─────────
     אחרי הוספה לסל המגירה אמורה להיפתח על־ידי התבנית. אם השרשרת
     שלה נשברת בשקט — אנחנו פותחים דרך ה-API שלה (show), ורק
     אם פתחנו אנחנו — מרעננים תוכן. אם היא כבר פתוחה: לא נוגעים. */

  function ensureDrawerOpen(withRefresh) {
    var d = getDrawer();
    if (!d || d.hasAttribute('open') || typeof d.show !== 'function') return;
    try { d.show(); } catch (_) {}
    if (withRefresh) refreshDrawer();
  }

  /* התבנית מודיעה שהוספה הצליחה — לוודא שהמגירה באוויר */
  document.addEventListener('product-ajax:added', function () {
    setTimeout(function () { ensureDrawerOpen(false); }, 120);
  });

  /* אירועי פתיחה גנריים (אינטגרציות) */
  ['cart:open', 'theme:cart:open'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(function () { ensureDrawerOpen(false); }, 50);
    });
  });

  /* רשת אחרונה: שליחת טופס מוצר. אם 900ms אחרי — עדיין סגורה,
     סימן שהזרימה של התבנית נפלה בדרך: פותחים בלי בקשת רענון נוספת. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[is="product-form"]')) return;
    var d = getDrawer();
    if (d && d.contains(f)) return; /* לא טפסים בתוך העגלה */
    setTimeout(function () { ensureDrawerOpen(false); }, 900);
  }, true);

  /* ───────── שומר-סף לסגירה ─────────
     הסגירה של Sleek ממתינה ל-transitionend מהרקע ורק אז משחררת
     את נעילת הגלילה (body.modal-show). אם המעבר בוטל — היא נתקעת
     באמצע סגירה לנצח. אנחנו לא נלחמים בה אלא משלימים אותה:
     1) המגירה עדיין פתוחה — hide() של התבנית.
     2) open ירד אבל hidden לא הגיע — משגרים את ה-transitionend
        החסר, ומכונת המצבים של התבנית מסיימת את עצמה כראוי.
     3) רשת אחרונה: modal-show על הגוף בלי אף מודאל פתוח — מוסר. */

  function unstickScrollLock() {
    var d = getDrawer();
    if (d) {
      if (d.hasAttribute('open')) {
        if (typeof d.hide === 'function') d.hide();
        return;
      }
      if (!d.hidden) {
        var ov = d.querySelector('.fixed-overlay');
        if (ov) ov.dispatchEvent(new Event('transitionend'));
      }
    }
    setTimeout(function () {
      var anyOpen = document.querySelector(
        'cart-drawer[open], drawer-component[open], modal-component[open], basic-modal[open], ' +
        'quick-view-modal[open], calculate-shipping[open], search-drawer[open], menu-drawer[open]'
      );
      if (!anyOpen) {
        document.body.classList.remove('modal-show', 'modal-showing');
      }
    }, 320);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var closer = e.target.closest('.cart-drawer .drawer__close-btn, .cart-drawer .fixed-overlay');
    if (!closer) return;
    setTimeout(unstickScrollLock, 700);
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') setTimeout(unstickScrollLock, 700);
  });

  /* חזרה לדף מה-bfcache עם נעילה תקועה — מנקים */
  window.addEventListener('pageshow', function () {
    checkoutQueued = false;
    checkoutSubmitting = false;
    var checkoutForm = document.querySelector('[data-ids-checkout-form]');
    setCheckoutPending(checkoutForm, false);
    setTimeout(unstickScrollLock, 60);
  });

  /* ───────── מנוע כמות עצמאי — אופטימי ומהיר ─────────
     משתלט מלא על פלוס/מינוס (capture) כדי שה-JS של התבנית לא
     יתחרה בנו: המספר מתעדכן מיידית, לחיצות רצופות נאספות
     לבקשת שרת אחת. */

  var qtyTimers = {};

  function commitQty(line, qty) {
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () {
      cartChangeLine(line, qty)
        .then(refreshDrawer)
        .catch(function () { refreshDrawer(); });
    }, 150);
  }

  /* תווית נגישות למינוס: הפחתה כשכמות מעל 1, הסרה כשהוא פח */
  function syncMinusLabels() {
    document.querySelectorAll('.cart-drawer quantity-input.ids-qty').forEach(function (qi) {
      var minus = qi.querySelector('.quantity__button[name="minus"]');
      if (!minus) return;
      var q = Number(qi.getAttribute('data-qty')) || 1;
      minus.setAttribute('aria-label', q <= 1 ? 'הסרת הפריט מהסל' : 'הפחתת כמות'); /* הסרת הפריט מהסל / הפחתת כמות */
    });
  }

  function stepQty(btn, dir) {
    var qi = btn.closest('quantity-input');
    var input = qi ? qi.querySelector('.quantity__input') : null;
    if (!input) return;
    var line = input.getAttribute('data-index');
    if (!line) return;
    var step = Number(input.getAttribute('step')) || 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? Number(maxAttr) : Infinity;
    var cur = Number(input.value) || 1;
    var next = dir > 0 ? Math.min(cur + step, max) : cur - step;

    if (next < 1) {
      /* פח — מחיקת השורה */
      var li = btn.closest('.cart-item');
      if (li) li.classList.add('is-updating');
      clearTimeout(qtyTimers[line]);
      cartChangeLine(line, 0)
        .then(refreshDrawer)
        .catch(function () { refreshDrawer(); });
      return;
    }
    if (next === cur) return;

    /* אופטימי: המסך מתעדכן מיד, השרת מתעדכן אחרי רגע של שקט */
    input.value = next;
    qi.setAttribute('data-qty', next);
    var item = btn.closest('.cart-item');
    if (item) {
      item.setAttribute('data-quantity', next);
      item.classList.add('is-updating');
    }
    syncMinusLabels();
    commitQty(line, next);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.cart-drawer quantity-input.ids-qty .quantity__button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    stepQty(btn, btn.getAttribute('name') === 'plus' ? 1 : -1);
  }, true);

  /* הקלדה ידנית של כמות */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var input = e.target.closest('.cart-drawer quantity-input.ids-qty .quantity__input');
    if (!input) return;
    e.stopPropagation();
    var line = input.getAttribute('data-index');
    if (!line) return;
    var qty = Math.max(0, Math.floor(Number(input.value) || 0));
    var qi = input.closest('quantity-input');
    var item = input.closest('.cart-item');
    if (item) item.classList.add('is-updating');
    if (qi && qty > 0) qi.setAttribute('data-qty', qty);
    commitQty(line, qty);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t;

    t = e.target.closest('[data-ids-coupon-toggle]');
    if (t) { toggleCoupon(t); return; }

    t = e.target.closest('[data-ids-coupon-apply]');
    if (t) { e.preventDefault(); applyCoupon(t); return; }

    t = e.target.closest('[data-ids-coupon-remove]');
    if (t) { removeCoupon(t); return; }

    t = e.target.closest('[data-ids-gift-add]');
    if (t) { addGift(t, t.getAttribute('data-ids-gift-add')); return; }

    t = e.target.closest('[data-ids-gift-change]');
    if (t) { openGiftSwap(t); return; }

    t = e.target.closest('[data-ids-gift-keep]');
    if (t) { closeGiftSwap(t); return; }

    t = e.target.closest('[data-ids-gift-swap]');
    if (t) { swapGift(t, t.getAttribute('data-ids-gift-swap')); return; }

    t = e.target.closest('[data-ids-upsell-size]');
    if (t) { /* v18: בחירת מידה — מעדכנת כפתור וצ'יפ, מתקפלת חזרה */
      if (!t.disabled) {
        var pitem = t.closest('.ids-upsell__item');
        if (pitem) {
          var pills = pitem.querySelectorAll('[data-ids-upsell-size]');
          for (var pi = 0; pi < pills.length; pi++) pills[pi].classList.remove('is-selected');
          t.classList.add('is-selected');
          var pbtn = pitem.querySelector('[data-ids-upsell-add]');
          if (pbtn) pbtn.setAttribute('data-variant', t.getAttribute('data-variant-id'));
          var chip = pitem.querySelector('[data-ids-upsell-chip]');
          if (chip) chip.innerHTML = 'מידה <b>' + esc(t.getAttribute('data-size-label') || t.textContent) + '</b> · <u>שינוי</u>'; /* מידה X · שינוי */
          var srow = pitem.querySelector('[data-ids-upsell-sizes]');
          if (srow) srow.setAttribute('hidden', '');
        }
      }
      return;
    }

    t = e.target.closest('[data-ids-upsell-chip]');
    if (t) { /* v18: פתיחה/סגירה של בחירת המידות */
      var citem = t.closest('.ids-upsell__item');
      var crow = citem ? citem.querySelector('[data-ids-upsell-sizes]') : null;
      if (crow) {
        if (crow.hidden) crow.removeAttribute('hidden');
        else crow.setAttribute('hidden', '');
      }
      return;
    }

    t = e.target.closest('.ids-upsell__dot');
    if (t) { goToUpsellSlide(t); return; } /* v15: ניווט בנקודות */

    t = e.target.closest('.ids-upsell__arrow');
    if (t) { /* v16: חיצים בדסקטופ — גם בקרוסלה וגם בגלריית ההצצה */
      var astage = t.closest('.ids-upsell__stage');
      var alist = astage ? astage.querySelector('.is-swipe') : null;
      if (alist && alist.children.length) {
        var aidx = nearestSlideIndex(alist) + (Number(t.getAttribute('data-ids-arrow')) || 1);
        aidx = Math.max(0, Math.min(alist.children.length - 1, aidx));
        var aslide = alist.children[aidx];
        if (aslide) aslide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      return;
    }

    /* ───── v19: הצצת מוצר ───── */
    t = e.target.closest('[data-ids-peek-close]');
    if (t) { closePeek(); return; }

    t = e.target.closest('[data-ids-peek-chart]');
    if (t) { toggleSizeChart(t); return; }

    t = e.target.closest('[data-ids-peek-size]');
    if (t) {
      var kwrap = t.closest('.ids-peek');
      if (kwrap) {
        var kpills = kwrap.querySelectorAll('[data-ids-peek-size]');
        for (var ki = 0; ki < kpills.length; ki++) kpills[ki].classList.remove('is-selected');
        t.classList.add('is-selected');
        var kbtn = kwrap.querySelector('[data-ids-peek-add]');
        if (kbtn) kbtn.setAttribute('data-variant', t.getAttribute('data-variant-id'));
      }
      return;
    }

    t = e.target.closest('[data-ids-peek-add]');
    if (t) {
      var kvid = t.getAttribute('data-variant');
      if (kvid) {
        setBusy(t, true);
        setDrawerBusy(true);
        cartAdd(kvid, 1)
          .then(function (cart) { closePeek(); return refreshDrawer(cart); })
          .catch(function () { closePeek(); refreshDrawer(); });
      }
      return;
    }

    /* הקשה על תמונה/שם בכרטיס האפסייל — פותחת את ההצצה */
    t = e.target.closest('.ids-upsell__item .ids-upsell__img, .ids-upsell__item .ids-upsell__title');
    if (t) {
      var hitem = t.closest('.ids-upsell__item');
      var hnd = hitem ? hitem.getAttribute('data-handle') : '';
      if (hnd) {
        var hbtn = hitem.querySelector('[data-ids-upsell-add]');
        openPeek(hnd, hbtn ? hbtn.getAttribute('data-variant') : '');
        return;
      }
    }

    t = e.target.closest('[data-ids-upsell-add]');
    if (t) { addUpsell(t); return; }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var sel = e.target.closest('[data-ids-line-variant]');
    if (sel) { swapLineVariant(sel); return; }
    var usel = e.target.closest('[data-ids-upsell-variant]');
    if (usel) {
      usel.classList.remove('ids-sel-invalid');
      /* בחירת מידה = הוספה לסל. פעולה אחת במקום שתיים */
      if (usel.value) {
        var uitem = usel.closest('.ids-upsell__item');
        var ubtn = uitem ? uitem.querySelector('[data-ids-upsell-add]') : null;
        if (ubtn) setBusy(ubtn, true);
        usel.disabled = true; /* מניעת שיגור כפול עד הרענון */
        setDrawerBusy(true);
        cartAdd(usel.value, 1)
          .then(refreshDrawer)
          .catch(function () { refreshDrawer(); });
      }
      return;
    }
    /* v14: תיקון — הפניה למשתנה box לא-מוגדר זרקה ReferenceError
       על כל אירוע change אחר (למשל שדה הקופון). מאתרים את תיבת
       התקנון מהאירוע עצמו. */
    var tbox = e.target.closest('[data-ids-terms-box]');
    if (tbox) { onTermsChange(tbox); }
  });


  /* ───────── אתחול + שרידות לרינדורים של התבנית ───────── */

  /* v24 (25.10.2026): טבעת הפוקוס הכחולה על ה-✕ במובייל — התבנית ממקדת את כפתור הסגירה תוכנתית בפתיחת הסל,
     והדפדפן מצייר טבעת focus-visible. מסמנים מיקוד שהגיע בלי מקלדת (ids-focus-pointer) —
     ה-CSS מסתיר את הטבעת רק אז; ניווט מקלדת מקבל טבעת כהה כרגיל. */
  var idsInputModality = 'pointer';
  document.addEventListener('keydown', function (e) {
    var k = e && e.key;
    if (k === 'Tab' || k === 'Enter' || k === ' ' || (k && k.indexOf('Arrow') === 0)) idsInputModality = 'keyboard';
  }, true);
  ['pointerdown', 'touchstart', 'mousedown'].forEach(function (name) {
    document.addEventListener(name, function () { idsInputModality = 'pointer'; }, true);
  });
  document.addEventListener('focusin', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#CartDrawer .drawer__close-btn') : null;
    if (!btn) return;
    btn.classList.toggle('ids-focus-pointer', idsInputModality !== 'keyboard');
  });

  /* v23 (24.10.2026): מתנת ברירת מחדל — הסל זכאי ולא נבחרה מתנה (data-state="choose")
     → מוסיפים אוטומטית את data-default-gift שהסקשן חישב. ניסיון אחד לכל וריאנט
     בטעינת העמוד, כדי שלא ניכנס ללולאה אם ההוספה נכשלת. */
  var defaultGiftTried = {};
  function handleDefaultGift() {
    var g = document.querySelector('[data-ids-gift][data-state="choose"][data-default-gift]');
    if (!g || giftGuardBusy || giftRequestBusy || g.getAttribute('data-ids-busy') === '1') return;
    var drawer = getDrawer();
    if (drawer && drawer.classList.contains('ids-busy')) return;
    var variantId = g.getAttribute('data-default-gift');
    if (!variantId || defaultGiftTried[variantId]) return;
    defaultGiftTried[variantId] = true;
    g.setAttribute('data-ids-busy', '1');
    giftRequestBusy = true;
    setDrawerBusy(true);
    cartAdd(variantId, 1)
      .then(function (cart) { return refreshDrawer(cart, { preserveGiftUpsell: true }); })
      .catch(function () { return refreshDrawer(); })
      .then(function () { giftRequestBusy = false; });
  }

  function init() {
    patchProductForms();
    handleOrphanGift();
    handleDefaultGift();
    flushQueuedCheckout();
    loadUpsell();
    syncMinusLabels();
    syncDeliveryEstimate();
    attachObserver();
  }

  function scheduleInit() {
    clearTimeout(initTimer);
    initTimer = setTimeout(init, 0);
  }

  function attachObserver() {
    var d = getDrawer();
    if (!d || d.getAttribute('data-ids-observed') === '1') return;
    d.setAttribute('data-ids-observed', '1');
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () { scheduleInit(); });
    observer.observe(d, { childList: true, subtree: true });
  }

  /* כשהתבנית מרעננת את הסל בעצמה (כמות/מחיקה/הוספה מבחוץ) */
  ['cart:refresh', 'cart:updated', 'on:cart:add', 'ajaxCart:added', 'fc:cart:added'
  ].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (e && e.detail && e.detail.source === 'ids-cart-extras') return;
      if(e && e.detail && e.detail.cart && typeof e.detail.cart.item_count === 'number') applyCartState(e.detail.cart);
      scheduleInit();
    });
  });

  document.addEventListener('visibilitychange', syncDeliveryEstimate);
  window.addEventListener('pageshow', syncDeliveryEstimate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

